import { SquaresFour, Garage, Stairs, DotsThree } from "@phosphor-icons/react";
import { Car, Motorcycle, Scooter, Bicycle, Truck } from "@phosphor-icons/react";

// Single source of truth for Parking V2 metadata on the frontend — mirrors the backend's
// PARKING_TYPES/VEHICLE_TYPES/CHARGE_FREQUENCIES in routes/parking_v2.py.
export const PARKING_TYPES = [
    { key: "open", label: "Open", icon: SquaresFour },
    { key: "covered", label: "Covered", icon: Garage },
    { key: "basement", label: "Basement", icon: Stairs },
    { key: "stilt", label: "Stilt", icon: Garage },
    { key: "other", label: "Other", icon: DotsThree },
];
export const PARKING_TYPE_MAP = Object.fromEntries(PARKING_TYPES.map((p) => [p.key, p]));

export const VEHICLE_TYPES = [
    { key: "car", label: "Car", icon: Car },
    { key: "motorcycle", label: "Motorcycle", icon: Motorcycle },
    { key: "scooter", label: "Scooter", icon: Scooter },
    { key: "electric_car", label: "Electric Car", icon: Car },
    { key: "electric_scooter", label: "Electric Scooter", icon: Scooter },
    { key: "bicycle", label: "Bicycle", icon: Bicycle },
    { key: "commercial", label: "Commercial", icon: Truck },
    { key: "other", label: "Other", icon: DotsThree },
];
export const VEHICLE_TYPE_MAP = Object.fromEntries(VEHICLE_TYPES.map((v) => [v.key, v]));

export const FUEL_TYPES = [
    { key: "petrol", label: "Petrol" },
    { key: "diesel", label: "Diesel" },
    { key: "electric", label: "Electric" },
    { key: "cng", label: "CNG" },
    { key: "hybrid", label: "Hybrid" },
    { key: "other", label: "Other" },
];
export const FUEL_TYPE_MAP = Object.fromEntries(FUEL_TYPES.map((f) => [f.key, f]));

export const VEHICLE_STATUSES = [
    { key: "active", label: "Active" },
    { key: "inactive", label: "Inactive" },
    { key: "sold", label: "Sold" },
    { key: "scrapped", label: "Scrapped" },
];
export const VEHICLE_STATUS_LABELS = Object.fromEntries(VEHICLE_STATUSES.map((s) => [s.key, s.label]));
export const VEHICLE_STATUS_VARIANTS = { active: "success", inactive: "neutral", sold: "warn", scrapped: "danger" };

export const CHARGE_FREQUENCIES = [
    { key: "one_time", label: "One Time" },
    { key: "monthly", label: "Monthly" },
    { key: "quarterly", label: "Quarterly" },
    { key: "half_yearly", label: "Half-Yearly" },
    { key: "annual", label: "Annual" },
];
export const CHARGE_FREQUENCY_MAP = Object.fromEntries(CHARGE_FREQUENCIES.map((f) => [f.key, f]));

export const SLOT_STATUS_LABELS = { available: "Available", allotted: "Allotted", reserved: "Reserved", inactive: "Inactive" };
export const SLOT_STATUS_VARIANTS = { available: "success", allotted: "default", reserved: "warn", inactive: "neutral" };

export const PASS_STATUS_VARIANTS = { active: "success", expired: "warn", cancelled: "danger" };

// Vehicle Approval V2 — resident-added vehicles start pending, admin/committee-added ones are
// auto-approved at entry. Only an APPROVED vehicle can be assigned a parking slot.
export const APPROVAL_STATUS_LABELS = { pending: "Pending Approval", approved: "Approved", rejected: "Rejected" };
export const APPROVAL_STATUS_VARIANTS = { pending: "warn", approved: "success", rejected: "danger" };

export const EMPTY_VEHICLE_FORM = {
    vehicle_type: "car", registration_number: "", make: "", model: "", variant: "",
    color: "", fuel_type: "", registration_state: "", owner_name: "", owner_contact: "", notes: "",
};

export const EMPTY_CREATE_SLOT_FORM = {
    slot_number: "", type: "4-wheeler", category: "covered", parking_type: "covered", block: "", floor: "", notes: "",
};

export const EMPTY_ALLOCATE_FORM = {
    flat_id: "", notes: "", charging_enabled: false, charge_amount: "", frequency: "monthly",
    charge_effective_date: "", charge_end_date: "", grace_period_days: "", late_fee: "", charge_notes: "",
};

export const EMPTY_SETTINGS_FORM = {
    enabled: false, charge_frequency: "monthly", default_charge: "", effective_from: "",
    applicable_parking_type: "", grace_period_days: "", late_fee: "", notes: "",
};
